module.exports = __webpack_public_path__ + "img/guojiadiantou.e45841b4.png";